import { InMemoryRepo } from "@mais-retorno-front/core-business/repositories/memory.repository";

export const makeAssetMemory = <T>() => {
  return new InMemoryRepo<T>();
}